// extracted by mini-css-extract-plugin
export var productImage = "_ld-1";
export var viewLink = "_ld-2";
export var wishlistItem = "_ld-0";